module.exports = __webpack_public_path__ + "img/H4.f9f58ab0.png";